import type { ButtonProps } from '@sravni/react-design-system/lib/Button';

import { LOANS_STATUS, OFFER_STATUS } from 'constants/offer';

import { isSatisfyOption } from 'shared/lib';
import type { TOffer, TPreapprovalOfferStep } from 'shared/types/TRankingService';

import { GoToRefOffer } from '../GoToRefOffer';
import { MoreInfo } from '../MoreInfo';
import { Pending } from '../Pending';
import { SendOffer } from '../SendOffer';

import { StartStepFlowButton } from './StartStepFlowButton';

type Props = {
  offer: TOffer;
  goNext: () => void;
  currentStep?: TPreapprovalOfferStep;
  isStepFlowActive: boolean;
  startStepFlow: () => void;
  isApplicationSending?: boolean;
  buttonProps?: ButtonProps;
};

export const OfferStepControls: FC<Props> = (props: Props) => {
  const { offer, currentStep, goNext, isStepFlowActive, startStepFlow, isApplicationSending, buttonProps } = props;
  const { additionalInfo, loansStatus, status } = offer;
  const isSendingApplicationDisabled =
    !additionalInfo?.isReferral &&
    (loansStatus === LOANS_STATUS.APPROVED || !isSatisfyOption([OFFER_STATUS.NEW], status));

  if (additionalInfo?.isPreapproving) {
    return <Pending {...buttonProps}>Ждём ответ</Pending>;
  }

  if (isSendingApplicationDisabled && (currentStep === 'application' || !isStepFlowActive)) {
    return (
      <MoreInfo
        offer={offer}
        buttonProps={buttonProps}
      />
    );
  }

  if (!currentStep) {
    if (additionalInfo?.isReferral) {
      return (
        <GoToRefOffer
          offer={offer}
          buttonProps={buttonProps}
        />
      );
    }
    return (
      <SendOffer
        offer={offer}
        buttonProps={{
          ...buttonProps,
          onClick: (e) => {
            goNext();
            buttonProps?.onClick?.(e);
          },
        }}
      />
    );
  }

  if (!isStepFlowActive) {
    return (
      <StartStepFlowButton
        offer={offer}
        buttonProps={{
          ...buttonProps,
          onClick: (e) => {
            startStepFlow();
            buttonProps?.onClick?.(e);
          },
        }}
      />
    );
  }

  switch (currentStep) {
    case 'iframe':
    case 'delivery':
    case 'confirmation':
      return <Pending {...buttonProps} />;
    case 'application': {
      if (additionalInfo?.isReferral) {
        return (
          <GoToRefOffer
            offer={offer}
            buttonProps={buttonProps}
          />
        );
      }
      return (
        <SendOffer
          offer={offer}
          buttonProps={{
            ...buttonProps,
            loading: isApplicationSending || buttonProps?.loading,
            onClick: (e) => {
              goNext();
              buttonProps?.onClick?.(e);
            },
          }}
        />
      );
    }
    default:
      return null;
  }
};
